import { render, staticRenderFns } from "./WhiteList.vue?vue&type=template&id=7880b2ba&scoped=true"
import script from "./WhiteList.vue?vue&type=script&lang=js"
export * from "./WhiteList.vue?vue&type=script&lang=js"
import style0 from "./WhiteList.vue?vue&type=style&index=0&id=7880b2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7880b2ba",
  null
  
)

export default component.exports